import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ConsortiumFormComponent } from "./consortium-form/consortium-form.component";
import { ConsortiumListComponent } from "./consortium-list/consortium-list.component";

const routes:Routes=[
    {
        path:'',
        data:{
            title:'Consortium',
        },
        component:ConsortiumListComponent
    },
    {
        path:'add',
        data:{
            title:'Add Consortium',
        },
        component:ConsortiumFormComponent
    },
    {
        path:'edit/:id',
        data:{
            title:'Edit Consortium',
        },
        component:ConsortiumFormComponent
    }
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class ConsortiumRoutingModule{

}